import React from 'react';
import SplitButton from './SplitButton';
import AddDocumentToCase from "./addDocumnetToCase";

const ExpertFilesPopup = ({
                              documentTypes,
                              refreshCaseFiles,
                              documentTypesForEditor,
                              caseInfo,
                              barcode,
                              userId,
                              objectOwner,
                              users,
                              permitTypeId,
                              caseData,
                              ownerIdentificationTemplateString,
                              exploitationIdentificationTemplateString,
                              permitTypeTitle,
                              userAddress


                          }) => {

    const renderDocumentComponent = (doc) => {
        switch (doc.documentTypeStatus) {
            case 13:
                return (
                    <AddDocumentToCase
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        permitTypeId={permitTypeId}
                        objectOwner={objectOwner}
                        docType={doc}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseData={caseData}
                        caseInfo={caseInfo}
                        users={users}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        userAddress={userAddress}
                    />
                );
            case 14:
                return (
                    <AddDocumentToCase
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        permitTypeId={permitTypeId}
                        docType={doc}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseData={caseData}
                        caseInfo={caseInfo}
                        users={users}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        userAddress={userAddress}
                    />
                );
            default:
                return null;
        }
    };
    return (
        <div>
            <SplitButton
                options={documentTypes}
                renderDocumentComponent={renderDocumentComponent}
                buttonLabel="დოკუმენტის შექმნა"
            />
        </div>
    );
};

export default ExpertFilesPopup;
